import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OwnerService } from '../_services/owner.service';
import { AuthenticationService } from '../_services';
import { Socialusers } from '../_models';
import { environment } from '../../environments/environment';
import { NgxSpinnerService } from "ngx-spinner";
import { Renderer2 } from '@angular/core';

@Component({
  selector: 'app-minside-auth-callback',
  templateUrl: './minside-auth-callback.component.html',
  styleUrls: ['./minside-auth-callback.component.scss']
})
export class MinsideAuthCallbackComponent implements OnInit {

  constructor(private activatedRoute: ActivatedRoute,
    private ownerService: OwnerService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private route: ActivatedRoute, private spinnerService: NgxSpinnerService,
    private render: Renderer2) { }

  userToken: string;
  socialusers = new Socialusers();
  referPage: string;
  companylogin: any;

  ngOnInit(): void {
    this.referPage = this.activatedRoute.snapshot.params['referPage'];
    this.userToken = this.activatedRoute.snapshot.params['id'];
    this.companylogin = this.activatedRoute.snapshot.queryParams['companylogin'];
    let roleType = this.companylogin === "1" || this.companylogin == 1 ? "Clinic" : "Owner";
    let loginRequest = { 'UserToken': this.userToken, 'RoleType': roleType }
    this.GetAuthTokenByUserToken(loginRequest);
  }

  GetAuthTokenByUserToken(loginRequest: any) {
    this.spinnerService.show();
    this.ownerService.getOwnerAuthToken(loginRequest).subscribe((res: any) => {
      this.spinnerService.hide();
      if (res.Status == 1) {
        this.socialusers.SocialID = res.Data.Id;
        this.socialusers.FirstName = res.Data.FirstName;
        this.socialusers.LastName = res.Data.LastName;
        this.socialusers.EmailID = res.Data.Email;
        this.socialusers.Address = res.Data.Address;
        this.socialusers.Zipcode = res.Data.ZipCode;
        this.socialusers.City = res.Data.City;
        this.socialusers.AuthToken = res.Data.AuthToken;
        this.socialusers.Provider = res.Data.Provider;
        this.socialusers.ContactNumber = res.Data.ContactNumber;
        this.socialusers.District = res.Data.District;
        this.socialusers.State = res.Data.StateName;
        this.socialusers.Country = res.Data.CountryName
        this.socialusers.Company = res.Data.ClinicName;
        this.socialusers.ClinicId = res.Data.ClinicId;
        this.saveResponse(this.socialusers);
      }
      else {
        alert("User Token is expired. Please login with Minside again");
        this.router.navigate(['login']);
      }
    })
  }

  saveResponse(socialusers: Socialusers) {
    if (this.companylogin) {
      this.spinnerService.show();
      this.saveCompanyProfileDetail(socialusers);
    }
    else {
      this.saveUserProfileDetail(socialusers);
    }
  }

  saveUserProfileDetail(socialusers: any) {
    this.authenticationService.login(socialusers).subscribe((res: any) => {
      this.socialusers = res.data;
      const today =  new Date();
      const tomorrow =  new Date(today.setDate(today.getDate() + 1));
      document.cookie = 'Authorization='+ res.JWTToken +'; expires=' + tomorrow;
      localStorage.setItem('socialusers', JSON.stringify(this.socialusers));
      localStorage.setItem('saveUserProfileDetail', JSON.stringify(this.socialusers));
      localStorage.setItem('Authorization', res.JWTToken);
      if (this.referPage == "found") {
        window.opener.location.href = `${environment.lostFoundBaseUrl}/report-found`;
        window.close();
      } else {
        window.opener.location.href = `${environment.lostFoundBaseUrl}/report-lost`;
        window.close();
      }
    });
  }

  saveCompanyProfileDetail(socialusers: any) {
    this.authenticationService.addUpdateCompanyLogin(socialusers).subscribe((res: any) => {
      this.spinnerService.hide();
      if (res.error === "") {
        this.socialusers = res.data;
        const today =  new Date();
        const tomorrow =  new Date(today.setDate(today.getDate() + 1));
        document.cookie = 'Authorization='+ res.JWTToken +'; expires=' + tomorrow;
        localStorage.setItem('socialusers', JSON.stringify(this.socialusers));
        localStorage.setItem('saveCompanyProfileDetail', JSON.stringify(this.socialusers));
        localStorage.setItem('Authorization', res.JWTToken);
        //window.opener.location.href = `${environment.lostFoundBaseUrl}`;
        this.router.navigate(["/"]);
        setTimeout(() => {
          let ele = document.getElementById('profileDropDown');
          ele.remove();
        }, 1000);
      }
      else {
        alert(res.error);
      }
    });
  }
}





